import { Flex, Text } from '@pancakeswap/uikit'
import React, { useMemo } from 'react'
import { productType } from 'state/giftCards/type'
import styled from 'styled-components'
import { formatNumber } from 'utils/formatNumber'

interface CardType {
    name: string,
    image:string,
    pricePromo: string,
    priceOrigin: string,
    unit: string,
    date:string,
    index:number,
    onClick:(newValue: any) => void
    activeItem: productType,
    itemId: string,
    isDefaultBrand:boolean,
    isPromo?:boolean,
    startPromo?:string
    endPromo?:string,
    isActive?:boolean
}

const CardItem:React.FC<CardType> = ({
    name,
    image,
    pricePromo,
    priceOrigin,
    unit,
    date,
    index,
    onClick,
    activeItem,
    itemId,
    isDefaultBrand,
    isPromo,
    startPromo,
    endPromo,
    isActive,
}) => {
    const isActive2 = useMemo(() => {
        if( Number(activeItem?.id) === Number(itemId) && isDefaultBrand === false ) return !false
        return false
    },[activeItem?.id, itemId, isDefaultBrand])
    const currentTime = Math.floor(new Date().getTime() / 1000)

    return (
        <CsWrapperCard key={index} onClick={onClick} isActive={isActive || isActive2}>
            <CsImg>
                <img src={!image ? '/images/giftcards/noProduct.png' : image} alt={name} />
                
                {date !== '' ? <CsTextDate>Hạn sử dụng: {date}</CsTextDate> : ''}
            </CsImg>
            <CsName>{name}</CsName>
            <Flex padding="20px" mt={["0rem", ,"1rem"]} mb={["0rem", ,"1rem"]} justifyContent="space-between" width="100%" alignItems="center">
                <TextPrice>{formatNumber(priceOrigin)}<span>{unit}</span> </TextPrice>
                {
                    (isPromo && ((Number(currentTime) > Number(startPromo)) && (Number(currentTime) < Number(endPromo)))) ?
                        <TextPriceOrigin fontWeight="700" color='white' style={{zIndex:10}}>
                            {Number(pricePromo).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{unit}
                        </TextPriceOrigin>
                    : ''
                }
            </Flex>
        </CsWrapperCard>
    )
}

const CsWrapperCard = styled.div<{isActive:boolean}>`
    border-radius: 22px;
    background: #FFF;
    box-shadow: 0px 12px 54px 0px rgba(210, 208, 208, 0.337);
    &:hover{
        box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;
        cursor: pointer;
    }
    @media screen and (max-width:768px) {
        box-shadow: 0px 12px 54px 0px rgba(156, 156, 156, 0.335);
            
    ${({ isActive }) => {
        if (isActive) {
            return `
                box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;
            `;
        }
        return "";
    }}
    }
    
    ${({ isActive }) => {
        if (isActive) {
            return `
                box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;
            `;
        }
        return "";
    }}
`

const CsImg = styled.div`
    padding: 10px;
    border-radius: 22px;
    position: relative;
    margin: 0 auto;
    height: 230px;
    overflow: hidden;
    img{
        height: 200px;
        object-fit: cover;
        margin: 0 auto;
        width: 100%;
    }
    @media screen and (max-width:768px) {
        padding: 10px;
        height: 230px;
        img{
            height: 230px;
        }
    }
    @media screen and (max-width:600px) {
        padding: 8px;
        height: 200px;
        img{
            height: 180px;
        }
    }
`
const CsName = styled(Text)`
    color: #141416;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    padding: 0 20px;
    @media screen and (max-width:1024px) {
        font-size: 16px;
    }
`
const TextPrice = styled(Text)`
    color: #FCA912;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    @media screen and (max-width:1024px) {
        font-size: 14px;
    }
`
const TextPriceOrigin = styled(Text)`
    color: #9596A6;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    text-decoration-line: line-through;
    @media screen and (max-width:1024px) {
        font-size: 14px;
    }
`
const CsTextDate = styled(Text)`
    position: absolute;
    top: 30px;
    right: 30px;
    /* width: 60%; */
    padding: 10px;
    border-radius: 9.44px;
    border: 1.18px solid rgba(28, 29, 32, 0.08);
    background: rgba(28, 29, 32, 0.35);
    box-shadow: 0px 4.72005033493042px 14.16015338897705px 0px rgba(28, 29, 32, 0.08);
    backdrop-filter: blur(2.36002516746521px);
    color: ${({theme}) => theme.colors.white}
`
export default CardItem